/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { Button, Card, Grid, Typography } from '@mui/material';
import { Box, Container } from '@mui/system';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FormHeaderGreeting from 'src/components/Greeting/FormHeaderGreeting';
import { RootState } from 'src/redux-store/appStore';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import { Fields } from 'src/ui-component/FormikFormLibrary/FormikTypes';
import Breadcrumb from 'src/ui-component/Breadcrumb';
import LoadingOverlay from 'src/components/common/LoadingOverlay';
import { httpRequest } from 'src/services/httpRequest';
import toast from 'react-hot-toast';
import { handleError } from 'src/redux-store/slices/errorSlice';
import PdfGenerator from 'src/ui-component/PdfGenerator';
import CustomModal from 'src/ui-component/customModal/CustomModal';
import CloseIcon from '@mui/icons-material/Close';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import FormikSelect from 'src/ui-component/FormikFormLibrary/FormikSelect';
import CustomButtonContained from 'src/components/CustomButton/CustomButtonContained';
import UploadDocs from 'src/ui-component/UploadDocs';

const NewApplication: React.FC = () => {
  const navigate = useNavigate();
  const userData = useSelector((store: RootState) => store.user.userDetails);
  const location = useLocation();
  const dispatch = useDispatch();
  const [clickedOn, setClickedOn] = useState<string>('');
  const { townshipId, permit } = useParams();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const [documentOptions, setDocumentOptions] = useState<string[]>([
    'Select Type'
  ]);
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const [docsErrorMessege, setDocsErrorMessege] = useState<string>('');
  const [file, setFile] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [applicationData, setApplicationData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  //Method to handle dynamic options for document type
  const handleDynamicOptions = (name: string, value: string) => {
    setDocumentOptions((prevOptions) => {
      const opt = ['Select Type'];
      const updatedApplicationData = { ...applicationData, [name]: value };

      if (updatedApplicationData.nonProfitProof === 'NJ State Non-Profit ID') {
        opt.push('NJ State Non-Profit ID (Required)');
      } else if (updatedApplicationData.nonProfitProof === 'IRS Form 501c3') {
        opt.push('IRS Form 501c3 showing their Non-Profit status (Required)');
      }
      if (updatedApplicationData.usedAtWalmart === 'yes') {
        opt.push('Wal-Mart Consent Form (Required)');
      } else if (updatedApplicationData.usedAtWalmart === 'no') {
        opt.push('Letter of Consent signed by the store owner or manager with the date(s) and time(s) listed (Required)');
      }
      return [...new Set(opt)];
    });
  };
  //Method to handle change in form fields
  const handleChange = (val, e) => {
    const data = applicationData;
    const { name } = e;
    if (name === 'usedAtWalmart' || name === 'nonProfitProof') {
      data[name] = val;
      handleDynamicOptions(name, val);
      setApplicationData(data);
    } else {
      data[name] = val;
      setApplicationData(data);
    }
  };

  //Form fields using Formik
  const formFields: Fields[] = [
    {
      fieldName: 'organizationName',
      fieldLabel: 'Organization Name',
      fieldType: 'text',
      required: true,
      initialValue: applicationData?.organizationName,
      dependency: handleChange
    },
    {
      fieldName: 'contactPersonName',
      fieldLabel: "Contact Person's Name",
      fieldType: 'text',
      required: true,
      initialValue: applicationData?.contactPersonName,
      dependency: handleChange
    },
    {
      fieldName: 'address',
      fieldLabel: 'Address',
      fieldType: 'note',
      required: true,
      initialValue: applicationData?.address,
      dependency: handleChange
    },
    {
      fieldName: 'purpose',
      fieldLabel: 'Purpose',
      fieldType: 'note',
      required: true,
      initialValue: applicationData?.purpose,
      dependency: handleChange
    },
    {
      fieldName: 'emailAddress',
      fieldLabel: 'Email Address',
      fieldType: 'email',
      required: true,
      initialValue: applicationData?.emailAddress,
      dependency: handleChange
    },
    {
      fieldName: 'phoneNumber',
      fieldLabel: 'Phone Number',
      fieldType: 'mobile',
      required: true,
      initialValue: applicationData?.phoneNumber,
      dependency: handleChange
    },
    {
      fieldName: 'nonProfitID',
      fieldLabel: 'Non-profit ID Number',
      fieldType: 'number',
      initialValue: applicationData?.nonProfitID,
      dependency: handleChange
    },
    {
      fieldName: 'nonProfitProof',
      fieldLabel: 'Which proof of non-profit do you have ?',
      fieldType: 'radio',
      required: true,
      options: [
        { label: 'NJ State Non-Profit ID', value: 'NJ State Non-Profit ID' },
        { label: 'IRS Form 501c3', value: 'IRS Form 501c3' }
      ],
      initialValue: applicationData?.nonProfitProof,
      dependency: handleChange,
      br: true
    },
    {
      fieldName: 'usedAtWalmart',
      fieldLabel: 'This will be used at Wal-Mart',
      fieldType: 'radio',
      required: true,
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],
      initialValue: applicationData?.usedAtWalmart,
      dependency: handleChange,
      br: true
    }
  ];

  const DynamicFormContent = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} mt={1}>
          <FormikSelect
            label={<>Select document type to upload <span style={{ color: 'red' }}> *</span></>}
            name={'documentType'}
            initialValue={applicationData?.documentType || 'Select Type'}
            options={documentOptions}
            fieldValue={{
              value: applicationData?.documentType || 'Select Type'
            }}
            // handleChange={(e) => {
            //   const { value } = e.target;
            //   const unique = [...uploadFiles, value]
            //     .filter((val, index, self) => self.indexOf(val) === index)
            //     .filter((type) => type !== 'Select Type');
            //   setApplicationData({
            //     ...applicationData,
            //     documentType: unique?.join(', ')
            //   });
            //   setUploadFiles(unique);
            // }}

            handleChange={(e) => {
              const { value } = e.target;
              if (value === 'Select Type') return;
              let newUploadFiles = [...uploadFiles];
              const containsSubstring = (item: string | number, substring: string): boolean => {
                return typeof item === 'string' && item.includes(substring);
              };
              if (
                typeof value === 'string' &&
                (value.includes('NJ State Non-Profit ID') || value.includes('IRS Form 501c3'))
              ) {
                newUploadFiles = newUploadFiles.filter(
                  item => !containsSubstring(item, 'NJ State Non-Profit ID') &&
                    !containsSubstring(item, 'IRS Form 501c3')
                );
                newUploadFiles.push(value);
              }
              else if (
                typeof value === 'string' &&
                (value.includes('Wal-Mart Consent Form') || value.includes('Letter of Consent'))
              ) {
                newUploadFiles = newUploadFiles.filter(
                  item => !containsSubstring(item, 'Wal-Mart Consent Form') &&
                    !containsSubstring(item, 'Letter of Consent')
                );
                newUploadFiles.push(value);
              }
              else if (!newUploadFiles.includes(value)) {
                newUploadFiles.push(value);
              }
              newUploadFiles = newUploadFiles.filter(type => type !== 'Select Type');
              setApplicationData({
                ...applicationData,
                documentType: newUploadFiles.join(', ')
              });
              setUploadFiles(newUploadFiles);
            }}
          />

          <>
            <Typography sx={{ color: '#8B0000' }} m={1}>
              {docsErrorMessege}
            </Typography>
            {uploadFiles?.length
              ? uploadFiles.map((item, i) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      background: 'lightgray',
                      width: '100%',
                      borderRadius: 1
                    }}
                    mt={1}
                  >
                    <Typography
                      display={'flex'}
                      alignItems={'center'}
                      px={{ xs: '10px', sm: '20px' }}
                      fontSize={{ xs: '12px', sm: 'auto' }}
                    >
                      <FilePresentIcon color="disabled" fontSize="small" />
                      {item}
                    </Typography>
                    <Box sx={{ display: 'flex' }}>
                      <Button
                        variant="outlined"
                        sx={{
                          color: '#8B0000',
                          border: 'none',
                          px: { xs: '10px', sm: '20px' }
                        }}
                        onClick={() => {
                          const updatedFiles = uploadFiles.filter(
                            (_, ind) => ind !== i
                          );
                          setUploadFiles(updatedFiles);
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </Button>
                    </Box>
                  </Box>
                );
              })
              : null}
            <CustomButtonContained
              title={<>Upload Documents <span style={{ color: 'red' }}> *</span></>}
              sx={{ mt: 2 }}
              disabled={!uploadFiles?.length}
              onClick={() => {
                setIsOpen(true);
                setDocsErrorMessege('');
              }}
            />
          </>
        </Grid>
      </Grid>
    );
  };

  const handleInsertApplication = async (data) => {
    setLoading(true);
    const requestData = { ...applicationData, ...data };
    const payload = {
      ApplicationStatus: clickedOn === 'Save Draft' ? 'Draft' : 'In Review',
      ApplicantName: `${userData.FirstName} ${userData.LastName}`,
      ApplicantPhoneNo: userDetails?.PhoneNumber,
      ApplicantAddress: userDetails?.TownshipName,
      Purpose: requestData?.purpose,
      OrganizationName: requestData?.organizationName,
      ContactPersonName: requestData?.contactPersonName,
      Address: requestData?.address,
      EmailAddress: requestData?.emailAddress,
      PhoneNumber: requestData?.phoneNumber,
      NotProfitIdNumber: requestData?.nonProfitID,
      ProofOfNotProfitType: requestData?.nonProfitProof,
      WalmartUsed: requestData?.usedAtWalmart === 'yes' ? true : false,
      DocumentFileUpload: file
    };
    const response = await httpRequest(
      'POST',
      `/charity_solicitor_permit_application/insert`,
      payload
    );
    if (response?.status === 'success') {
      setLoading(false);
      toast.success('Application submitted successfully.');
      navigate(
        `/${townshipId}/Clerk Department/${permit}/${clickedOn === 'Save Draft' ? 'draft-application' : 'application-list'
        }`
      );
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      setLoading(false);
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
  };

  const handleSubmitAndDraft = async (data) => {
    if (uploadFiles?.length !== file?.length) {
      setDocsErrorMessege('Please upload all required documents.');
      return;
    } else {
      handleInsertApplication(data);
    }
  };

  return loading ? (
    <LoadingOverlay />
  ) : (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Charitable Solicitations'}
        PageTitle={'New Application'}
      />
      <FormHeaderGreeting
        name={`${userData?.FirstName} ${userData?.LastName}`}
        applicationType="new"
      />
      <Card>
        <Box
          m={{ md: 3, xs: 1 }}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <PdfGenerator
            PermitName={'Charitable Solicitations'}
            allFields={formFields}
          />
        </Box>
        <Box m={{ md: 3, xs: 1 }}>
          <FormikForm
            allFields={formFields}
            buttonTitle={['Cancel', 'Save Draft', 'Submit']}
            formMethod={handleSubmitAndDraft}
            buttonPlacement={'right'}
            setClickedOn={setClickedOn}
            clickProp
            content={<DynamicFormContent />}
            handleOtherButton={() => {
              navigate(`/dashboard/${permit}`);
            }}
          />
        </Box>
      </Card>
      <CustomModal
        title={'Upload documents'}
        IsOpen={IsOpen}
        setIsOpen={setIsOpen}
        loading={loading}
        onSave={() => setIsOpen(false)}
        actionButtons={['Close']}
        content={
          <UploadDocs
            documentToUpload={uploadFiles}
            ApplicationID={''}
            file={file}
            permitName={'CharSol'}
            setFile={setFile}
            setLoading={setLoading}
            reFetch={() => { }}
          />
        }
      />
    </Container>
  );
};

export default NewApplication;
